import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles } from '@/styles';
import { iconCheckmarkCircle } from '../icons';

@customElement('fg-usps')
export class FgUsps extends LitElement {
  @property({ type: Array })
  usps?: { text: string }[];

  @property({ type: String })
  type: 'salable mobile' | 'mobile-collapsible' | 'mobile' | 'desktop' =
    'desktop';

  render() {
    return html`
      <ul class="usp ${this.type}">
        ${this.usps && this.usps.length
          ? this.usps.map(usp => {
              return html`
                <li>
                  <span>${iconCheckmarkCircle}</span>
                  ${usp.text}
                </li>
              `;
            })
          : html`
              <li>
                <span>${iconCheckmarkCircle}</span>
                ${t('labels.freeShipping')}
              </li>
              <li>
                <span>${iconCheckmarkCircle}</span>
                ${t('labels.alwaysAPrintProof')}
              </li>
              <li>
                <span>${iconCheckmarkCircle}</span>
                ${t('labels.transparentPrice')}
              </li>
            `}
      </ul>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .usp {
        font-family: 'Poppins', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
      }

      .usp.desktop {
        display: none;
      }

      .usp.mobile {
        display: flex;
        padding: 20px;
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
      }

      .usp.salable {
        margin-top: 40px;
      }

      .usp.mobile-collapsible {
        padding: 8px 0 20px 0;
        align-items: start;
        gap: 12px;
      }

      .usp li {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .usp li span {
        color: var(--fg-usp, var(--fg-fallback-usp));
        width: 16px;
        height: 16px;
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        .usp {
          align-items: initial;
        }

        .usp.desktop {
          display: flex;
        }

        .usp.mobile {
          display: none;
        }
      }
    `,
  ];
}
